import { ClipLoader } from "react-spinners";
import styles from "./css/LoadingScreen.module.css";

function LoadingScreen() {
  return (
    <div className={styles.screen}>
      <ClipLoader loading={true} size={32} color="var(--icon-disabled-color)" />
    </div>
  );
}

export default LoadingScreen;
